import React from 'react';
import { Container, Row, Col, Image } from 'react-bootstrap';

const About: React.FC = () => {
  return (
    <Container className="my-5">
      <Row className="text-center mb-5">
        <Col>
          <h2 className="display-5 fw-bold">Hakkımızda</h2>
          <p className="lead text-muted">Kuruluşumuz, değerlerimiz ve hedeflerimiz.</p>
        </Col>
      </Row>

      {/* Hakkımızda Section */}
      <Row className="align-items-center mb-5">
        <Col md={6}>
          <h3>Hakkımızda</h3>
          <p>
            <strong>Göktaş Mekanik ve Doğalgaz</strong> olarak, 1998 yılından bu yana 
            <strong> mekanik tesisat, daire tesisatı, doğalgaz sistemleri, yangın tesisatı, motor, pompa, eşanjör, genleşme tankı, boyler, boru tamiri, panel çit, çim çit, hidrofor ve kazan sistemleri uygulamaları </strong> 
             başta olmak üzere, birçok teknik alanda faaliyet gösteriyoruz. Sadece sistem kurulumu değil; 
            <strong> bakım, onarım, iyileştirme ve yenileme hizmetleri</strong> de sunarak, müşterilerimizin 
            ihtiyaçlarına uçtan uca çözümler üretiyoruz. Aynı zamanda malzeme satışı sektöründe de faaliyet göstermekteyiz.
          </p>
          <p>
            Yıllar içinde gerçekleştirdiğimiz bireysel ve kurumsal projelerle sektörde güven kazanmış, 
            teknolojiye entegre, dinamik bir yapıya ulaştık. Kurumsal projelerde edindiğimiz tecrübeyi, 
            bireysel müşterilerimizin beklentileriyle birleştirerek; işlevsel, enerji verimli ve uzun ömürlü 
            sistemler kurmayı hedefliyoruz.
          </p>
          <p>
            Projelendirme sürecinden uygulamaya, devreye almadan periyodik bakıma kadar her aşamada 
            <strong> şeffaflık ve kalite</strong> ilkesiyle hareket ediyoruz. Amacımız yalnızca teknik ihtiyaçlara 
            yanıt vermek değil; <strong>yaşam ve çalışma alanlarınıza değer katacak çözümler</strong> üretmektir.
          </p>
          <p>
            Bugün olduğu gibi, gelecekte de <strong>güvenilir, sürdürülebilir ve yüksek performanslı sistemler </strong> 
            sunan öncü bir firma olma vizyonuyla çalışmaya devam ediyoruz.
          </p>
        </Col>
        <Col md={6} className="text-center">
          <Image 
            src={process.env.PUBLIC_URL + '/images/hakkimizda.jpeg'} 
            alt="Hakkımızda" 
            fluid 
            rounded 
          />
        </Col>
      </Row>

      {/* Vizyonumuz Section */}
      <Row className="align-items-center mb-5">
        <Col xs={{ order: 1 }} md={{ span: 6, order: 1 }} className="text-center">
          <Image 
            src={process.env.PUBLIC_URL + '/images/vizyonumuz.jpeg'} 
            alt="Vizyonumuz" 
            fluid 
            rounded 
          />
        </Col>
        <Col xs={{ order: 2 }} md={{ span: 6, order: 2 }}>
          <h3>Vizyonumuz</h3>
          <p>
            <strong>Mekanik tesisat, daire tesisatı, doğalgaz sistemleri, yangın tesisatı, motor, pompa, eşanjör, genleşme tankı, boyler, boru tamiri, panel çit, çim çit, hidrofor ve kazan sistemleri uygulamaları ile bu sistemlerin bakım ve onarım süreçlerinde</strong>; 
            kaliteli, güvenilir ve sürdürülebilir hizmet anlayışımızı sürdürerek, sektörde tercih edilen ve referans gösterilen bir marka olmak.
          </p>
          <p>
            Yenilikçi çözümler, teknolojiye hızlı uyum ve müşteri odaklı yaklaşımımızla, hizmet verdiğimiz her projede 
            <strong> standartları yükselten</strong>, uzun vadeli çözümler sunan bir yapı oluşturmayı hedefliyoruz.
          </p>
        </Col>
      </Row>

      {/* Misyonumuz Section */}
      <Row className="align-items-center">
        <Col md={6}>
          <h3>Misyonumuz</h3>
          <p>
            1998 yılından bu yana edindiğimiz deneyim ve teknik altyapıyla; 
            <strong> mekanik tesisat, daire tesisatı, doğalgaz sistemleri, yangın tesisatı, motor, pompa, eşanjör, genleşme tankı, boyler, boru tamiri, panel çit, çim çit, hidrofor ve kazan ekipmanları </strong> 
            gibi alanlarda, müşterilerimize <strong>kurulum, bakım, onarım ve sistem yenileme </strong> 
            hizmetleri sunuyoruz.
          </p>
          <p>
            Her projede; <strong>güvenilirlik, şeffaflık, zamanında teslimat ve müşteri memnuniyetini </strong> 
            temel alarak, hem bireysel hem kurumsal ölçekte 
            <strong> verimli, uzun ömürlü ve enerji tasarruflu sistemler</strong> kurmak için çalışıyoruz.
          </p>
          <p>
            Amacımız; yalnızca teknik ihtiyaçları karşılamak değil, 
            <strong> değer katan ve sürdürülebilir sonuçlar</strong> üreten bir iş anlayışıyla hareket etmektir.
          </p>
        </Col>
        <Col md={6} className="text-center">
          <Image 
            src={process.env.PUBLIC_URL + '/images/misyonumuz.jpeg'} 
            alt="Misyonumuz" 
            fluid 
            rounded 
            style={{ maxHeight: '500px', width: '100%', objectFit: 'cover' }}
          />
        </Col>
      </Row>
    </Container>
  );
};

export default About;